const initialState = {
    posts: [],
    login: null,
    topUsers: []
}

export default initialState